import styled from "styled-components";

export const InfoContainer = styled("div")`
  padding: 10px 20px;
  svg {
    cursor: pointer;
  }
`;

export const FormContainer = styled("form")`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  flex-wrap: wrap;
`;

export const FormRowInputContainer = styled("div")`
  display: flex;
  flex-direction: column;
  flex-wrap: wrap;
  max-width: 330px;
  .input {
    border: 0.5px solid var(--tertiary-color);
    border-radius: 6px;
    min-height: 46px;
  }
  label {
    font-weight: 300;
    font-size: var(--font-size-xs);
    margin: 0 10px 5px 0;
  }
  button {
    @media screen and (max-width: 768px) {
      font-weight: 500;
      font-size: var(--font-size-lg);
    }
  }
  .btn-link {
    font-weight: 500;
    font-size: var(--font-size-sm);
  }

  input:not(.OTP-field) {
    &[type="password"] {
      font-size: var(--font-size-xxl);
      @media screen and (max-width: 768px) {
        font-size: var(--font-size-base);
      }
    }
  }
`;

export const EyesContainer = styled("span")`
  width: 33px;
`;
